import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";

// views

import Login from "views/auth/Login";
import Dashboard from "views/admin/Dashboard.js";
import Companies from "views/admin/Companies";
import Invoices from "views/admin/Invoices";
import CreateCompanyPage from "views/admin/CreateCompanyPage";
import Products from "views/admin/Products";
import CreateProductPage from "views/admin/CreateProductPage";

export default function Admin() {
  return (
    <>
      <Sidebar />
      <div className="md:ml-64 bg-blueGray-100 h-screen md:min-h-full">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24 bg-blueGray-100">
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/companies" exact component={Companies} />
            <Route path="/admin/invoices" exact component={Invoices} />
            <Route path="/admin/company" exact component={CreateCompanyPage} />
            <Route path="/admin/company/:id" exact component={CreateCompanyPage} />"
            <Route path="/admin/products" exact component={Products} />
            <Route path="/admin/product" exact component={CreateProductPage} />
            <Route path="/admin/product/:id" exact component={CreateProductPage} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
        </div>
      </div>
    </>
  );
}
